import { apiRequest } from "./client";

export const fetchDashboard = async () => {
  const payload = await apiRequest("/dashboard");
  return payload.data;
};
